import {
  ForgeAttributePredicateType,
  ForgeAttributeType,
  PredicateType,
} from '../gql/graphql';

export const getPredicateLabels = (
  translate: (key: string) => string = (key) => key
) =>
  new Map([
    [PredicateType.AnyOf, translate('predicate.any-of')],
    [PredicateType.Equals, translate('predicate.equals')],
    [PredicateType.NotEquals, translate('predicate.not-equals')],
    [PredicateType.GreaterThan, translate('predicate.greater-than')],
    [PredicateType.LessThan, translate('predicate.less-than')],
    [PredicateType.Contains, translate('predicate.contains')],
    [PredicateType.NotContains, translate('predicate.not-contains')],
    [PredicateType.Exists, translate('predicate.exists')],
    [PredicateType.NotExists, translate('predicate.not-exists')],
    [PredicateType.FromRegex, translate('predicate.from-regex')],
  ]);

const formatAttribute = (attribute: ForgeAttributeType): string => {
  const { name, category } = attribute;
  return `${category} - ${name}`;
};

export const formatPredicate = (
  predicate: ForgeAttributePredicateType,
  translate: (key: string) => string = (key) => key
): string => {
  const { attribute, predicate: predicateType, attributeValues } = predicate;
  const label =
    getPredicateLabels(translate).get(predicateType)?.toLowerCase() || '';
  if (predicateType === PredicateType.Exists) {
    return `(${formatAttribute(attribute)}) ${label}`;
  }
  if (predicateType === PredicateType.NotExists) {
    return `(${formatAttribute(attribute)}) ${label}`;
  }
  if (predicateType === PredicateType.AnyOf) {
    return `(${formatAttribute(attribute)}) ${label} (${attributeValues?.join(
      ', '
    )})`;
  }
  return `(${formatAttribute(attribute)}) ${label} (${attributeValues?.[0]})`;
};

export const formatAttributeValues = (
  operator: PredicateType,
  attributeValues: string[] | null | undefined
): string | null => {
  if (
    operator === PredicateType.Exists ||
    operator === PredicateType.NotExists
  ) {
    return null;
  } else if (
    operator === PredicateType.AnyOf &&
    attributeValues &&
    attributeValues.length > 0
  ) {
    return attributeValues.join(', ');
  } else if (attributeValues && attributeValues.length > 0) {
    return attributeValues[0];
  } else {
    return null;
  }
};
